module.exports = __webpack_public_path__ + "media/components/assets/icons/star_blue_empty-574aef73b5050c02ac8fcf7360a797fb.svg";